import { ArrowDownIcon, ArrowUpIcon } from '@chakra-ui/icons'
import { Box, Th, Thead, Tr, chakra } from '@chakra-ui/react'

export interface IncidentRulesPageHeaderIProps {
  headerGroups: any
}

export const TableHeaders = ({
  headerGroups,
}: IncidentRulesPageHeaderIProps) => {
  return (
    <Thead
      bgColor='#F2F4F9'
      data-testid='sopsPage_table_header'
      overflowX='hidden'
      overflowY='auto'
    >
      {headerGroups.map((headerGroup, index) => (
        <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
          {headerGroup.headers.map((column) => (
            <Th
              {...column.getHeaderProps()}
              alignItems='center'
              borderColor='#D5DCE4'
              color='#2D2E41'
              d='flex'
              fontSize='14px'
              fontWeight='semibold'
              isNumeric={column?.isNumeric}
              key={column.id}
              letterSpacing='-1px'
              px='4'
              textTransform='capitalize'
            >
              <Box d='inline-block' {...column?.getSortByToggleProps()}>
                {column.render('Header')}
              </Box>
              <chakra.span>
                {column?.isSorted ? (
                  column?.isSortedDesc ? (
                    <ArrowDownIcon aria-label='sorted descending' />
                  ) : (
                    <ArrowUpIcon aria-label='sorted ascending' />
                  )
                ) : null}
              </chakra.span>
            </Th>
          ))}
        </Tr>
      ))}
    </Thead>
  )
}
